import { useEffect, type CSSProperties } from 'react';

import type { StaffOption } from '../../api/staff-options';

const LIST_STYLE: CSSProperties = {
  position: 'absolute',
  zIndex: 20,
  top: 'calc(100% + 2px)',
  left: 0,
  right: 0,
  margin: 0,
  padding: 4,
  listStyle: 'none',
  maxHeight: 220,
  overflowY: 'auto',
  background: 'var(--nb-bg)',
  border: '1px solid var(--nb-border-2)',
  borderRadius: 8,
  boxShadow: 'var(--nb-shadow-md)',
};

export default function PeoplePickerList({
  id,
  label,
  options,
  active,
  selectedId,
  status,
  onPick,
}: {
  id: string;
  label: string;
  options: StaffOption[];
  active: number;
  selectedId: string;
  status: 'loading' | 'failed' | 'ready';
  onPick: (user: StaffOption) => void;
}) {
  useEffect(() => {
    document.getElementById(`${id}-${active}`)?.scrollIntoView?.({ block: 'nearest' });
  }, [id, active, options]);
  const note =
    status === 'loading'
      ? 'Searching…'
      : status === 'failed'
        ? 'Couldn’t load people. Try again.'
        : options.length === 0
          ? 'No one matches.'
          : null;
  return (
    <ul id={id} role="listbox" aria-label={`${label} options`} style={LIST_STYLE}>
      {note && (
        <li
          role="presentation"
          style={{ padding: '6px 8px', fontSize: 12, color: 'var(--nb-subtle)' }}
        >
          {note}
        </li>
      )}
      {options.map((u, i) => (
        <li
          key={u.id}
          id={`${id}-${i}`}
          role="option"
          aria-selected={u.id === selectedId}
          onMouseDown={(e) => {
            e.preventDefault();
            onPick(u);
          }}
          style={{
            padding: '6px 8px',
            fontSize: 12.5,
            borderRadius: 6,
            cursor: 'pointer',
            color: 'var(--nb-ink)',
            fontWeight: u.id === selectedId ? 700 : 500,
            background: i === active ? 'var(--nb-primary-soft)' : 'transparent',
          }}
        >
          {u.name}
        </li>
      ))}
    </ul>
  );
}
